import React, { useEffect, useState } from 'react';
import LandingPageV2View from './LandingPageV2View';
import { paths } from '../../config/router.config';
import wsclients from '../../services/wsclients';
import CustomAlert from '../../components/CustomAlert';
import { useTranslation } from 'react-i18next';
import CustomLoading from '../../components/CustomLoading';
import Geocode from 'react-geocode';
import { configData, configuration } from '../../config/main.config';
import { getAddressHome, getAppConfig, getPackageSeleted, isVumaReachPackage, setAddressHome, setPackageInfo, setPackageSeleted, setUTMInfo } from '../../utils/commons';
import { capitalize, sortByPrice, sortByOrderField, checkAddressPreorder, STEPS_REGISTER, PRODUCT_TYPES, PRODUCT_TYPE_CODES } from '../../utils/util';

export default function LandingPageV2Controller(props) {
    console.log("AAAA LandingPageV2Controller props: ", props)
    const { t } = useTranslation();

    const [showLoading, setShowLoading] = useState(false);
    const [packages, setPackages] = useState([]);
    const [address, setAddress] = useState(null);
    const [message, setMessage] = useState({});
    const [choosePackage, setChoosePackage] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showTerm, onShowTerm] = useState(false);
    const [addresses, setAddresses] = useState([]);
    const [addressInfor, setAddressInfor] = useState(null);
    const [showListAddresses, setShowListAddresses] = useState(false);
    const [addressSelected, setAddressSelected] = useState(null);
    const [searchType, setSearchType] = useState(0);
    const [ispLocation, setISPLocation] = useState(null);
    const [openserveServices, setOpenserveServices] = useState([]);
    const [openModalBuilding, setOpenModalBuilding] = useState(false)
    const [building, setBuilding] = useState([])
    const [address1Map, setAddress1Map] = useState(null);
    const [packageConfirmation, setPackageConfirmation] = useState(null);

    useEffect(() => {
        onLoadData();
    }, []);

    useEffect(() => {
        if (address1Map) onSelectAddress1Map(address1Map)
    }, [address1Map])

    // useEffect(() => {
    //     if (choosePackage) {
    //         const selected = getPackageSeleted();
    //         if (selected) {
    //             // props.history.push(paths.package_info);
    //             setPackageConfirmation(selected)
    //         }
    //     }
    // }, [choosePackage]);

    const onLoadData = async () => {
        setShowLoading(true);
        var url = new URL(window.location.href);
        console.log("url===", url);
        var utm_source = url.searchParams.get("utm_source");
        var utm_campain = url.searchParams.get("utm_campaign");
        if (utm_source && utm_campain) {
            setUTMInfo({
                utm_source: utm_source,
                utm_campain: utm_campain,
            })
        }
        await onLoadProducts();
        setShowLoading(false);
    }

    const onLoadProducts = async () => {
        try {
            let flyLiteFamily = document._portalConfig.flyLiteFamily;
            let flySmartFamily = document._portalConfig.flySmartFamily;
            let flyUltraFamily = document._portalConfig.flyUltraFamily;

            let productFlyLites = [];
            let productFlySmarts = [];
            let productFlyUltras = [];

            var result = await wsclients.lab4services.getProductsV3();
            console.log("result getProducts===", result);
            if (result.code == 'OK') {
                if (result.data) {
                    for (let i = 0; i < result.data.length; i++) {
                        let p = result.data[i];
                        // if (p.product && p.product.custom_fields && p.product.custom_fields.length > 0) {
                        //     p.product.custom_fields.forEach(c => {
                        //         if (c.key == 'product_price_r') {
                        //             p.price_r = parseFloat(c.value);
                        //         }
                        //         if (c.key == 'product_price_o') {
                        //             p.price_o = parseFloat(c.value);
                        //         }
                        //     });
                        // }
                        if (p.product_type == "openserve" && document._portalConfig.hideOpenserveProducts)
                            continue;

                        if (p.product_type == "vuma_core" && document._portalConfig.hideVumacoreProducts)
                            continue;

                        if (p.family.toLowerCase() === flyLiteFamily.toLowerCase())
                            productFlyLites.push(p);
                        else if (p.family.toLowerCase() === flySmartFamily.toLowerCase())
                            productFlySmarts.push(p);
                        else if (p.family.toLowerCase() === flyUltraFamily.toLowerCase())
                            productFlyUltras.push(p);
                    }
                }
                console.log("result productFlyLites===", productFlyLites);
                console.log("result productFlySmarts===", productFlySmarts);
                console.log("result productFlyUltras===", productFlyUltras);
                let pkgs = [];
                pkgs.productflylites = productFlyLites.sort(sortByPrice).sort(sortByOrderField);
                pkgs.productflysmarts = productFlySmarts.sort(sortByPrice).sort(sortByOrderField);
                pkgs.productflyultras = productFlyUltras.sort(sortByPrice).sort(sortByOrderField);

                console.log("result pkgs===", pkgs);
                setPackages(pkgs ? pkgs : []);
            }
        }
        catch (ex) {
            console.log("getProducts exception: ", ex);
        }
    }

    const onSelectPackage = async (product) => {
        let packageSelected = {
            ...product,
        };
        if (product && !isVumaReachPackage(product.product_type)) {
            packageSelected.name = product.product && product.product.name ? product.product.name : null;
            packageSelected.id = product.product && product.product.id ? product.product.id : null;
            packageSelected.sku = product.product && product.product.sku ? product.product.sku : null;
        }
        setPackageSeleted(packageSelected);
        if (choosePackage) {
            setPackageConfirmation(packageSelected)
        //    props.history.push(paths.package_info);
        } else {
            setShowModal(true)
        }
    }

    const onSetAddressSelected = async (address) => {
        if (address) {
            setAddressSelected(address);

            setAddressHome({
                ...addressInfor,
                ...address,
            });
            setShowListAddresses(false);
            let locationAvaible = await checkLocationAvaibleOrder();

            if (locationAvaible && locationAvaible.isCheck) {
                if (locationAvaible.building && locationAvaible.building.length > 0) {
                    setBuilding(locationAvaible.building)
                    setOpenModalBuilding(true);
                } else
                    setShowModal(true)
            }

            setShowLoading(false);
        }
    }

    const onSetBuildingSelected = async (data) => {
        setAddressSelected({ ...addressSelected, building: data });
        setAddressHome({
            ...addressInfor,
            ...addressSelected,
            building: data
        });
        setOpenModalBuilding(false)
        setShowModal(true)
    }

    const checkLocationAvaibleOrder = async () => {
        setShowLoading(true)
        let isCheck = false;
        let building = []
        try {
            let addressSelected = getAddressHome();
            if (addressSelected) {
                let result = await wsclients.lab4services.checkLocationAvaibleOrderV3({
                    locationId: addressSelected.premise_ref_isp,
                    openserve_ref_isp: addressSelected.openserve_ref_isp,
                    lat: addressSelected.latitude,
                    lng: addressSelected.longitude,
                    uuid: addressSelected.uuid,
                    metrofibre_ref_isp:addressSelected.metrofibre_ref_isp
                });
                setShowLoading(false)
                console.log("checkLocationAvaibleOrder result: ", result);                
                if (result.code === 'OK') {
                    // check building 
                    building = result.data && result.data.openserve_building_infos ? result.data.openserve_building_infos : [];
                    let isAllowCreateOrderVuma = result?.data?.is_available_create_order || false;
                    let isAllowCreateOrderMetro = result?.data?.is_available_create_order_metrofibre || false;
                    let isAllowCreateOrderOP = result?.data?.is_availabe_create_openserve_order || false;
                    let isAllowCreateOrderOctotel = result?.data?.octotel_services?.length > 0 ? true : false;
                    // isAllowCreateOrderVuma = true;//FAKE
                    if (isAllowCreateOrderVuma) {
                        if (addressSelected.tactical) {
                            setAvailableVumaReachProducts1010();
                        } else {
                            setAvailableVumaProducts();
                        }
                        isCheck = true;

                    }
                    if (isAllowCreateOrderMetro) {
                        setAvailableMetroFibreProducts();
                        isCheck = true;
                    }
                    if (isAllowCreateOrderOP) {
                        let _openserveProducts = result.data.openserve_services ? result.data.openserve_services : [];
                        isCheck = onCheckProductsOpenserve(_openserveProducts);
                    }

                    if (isAllowCreateOrderOctotel) {
                        isCheck = checkProductsOctotel(result.data.octotel_services)
                    }
                    if (result.data && !isAllowCreateOrderOP && !isAllowCreateOrderVuma 
                        && addressSelected.product_types != 'OC' && !result.data.pre_order_allowed && !isAllowCreateOrderMetro
                    ) {
                        console.log("checkLocationAvaibleOrder result: ", result);
                        setMessage({
                            show: true,
                            content: result.data && result.data.descriptions ? result.data.descriptions : t('address_used')
                        });
                    }

                }
            }
        } catch (ex) {
            console.log("checkLocationAvaibleOrder exception: ", ex);
        }
        if (!isCheck) {
            setMessage({
                show: true,
                content: t('address_used')
            });
        }
        return { isCheck, building };
    }

    const checkProductsOctotel = (octotel_services) => {
        let isCheck = false;
        try {
            let _octotelProducts = [];
            let _productflylites = [];
            let _productflysmarts = [];
            let _productflyultras = [];
            let _packages = {}
            if (octotel_services && octotel_services.length > 0 && packages) {
                if (packages.productflylites) {
                    packages.productflylites.forEach(item => {
                        let isAvailable = false;

                        let existItems = octotel_services.filter(x => item.code.includes(x.productCode));
                        if (existItems && existItems.length > 0) {
                            isAvailable = true;
                            let existPackage = _octotelProducts.filter(x => item.code.includes(x.productCode));
                            if (!existPackage || (existPackage && existPackage.length == 0)) {
                                _octotelProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: true,
                                    product_type_code: 'OC'
                                });
                            } else {
                                _octotelProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: false,
                                    product_type_code: 'OC'
                                });
                            }
                        } else {
                            _octotelProducts.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OC'
                            });
                        }

                        _productflylites.push({
                            ...item,
                            is_available: isAvailable,
                            product_type_code: 'OC'
                        });
                    })
                }

                if (packages.productflysmarts) {
                    packages.productflysmarts.forEach(item => {
                        let isAvailable = false;

                        let existItems = octotel_services.filter(x => item.code.includes(x.productCode));
                        if (existItems && existItems.length > 0) {
                            isAvailable = true;
                            let existPackage = _octotelProducts.filter(x => item.code.includes(x.productCode));
                            if (!existPackage || (existPackage && existPackage.length == 0)) {
                                _octotelProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: true,
                                    product_type_code: 'OC'
                                });
                            } else {
                                _octotelProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: false,
                                    product_type_code: 'OC'
                                });
                            }
                        } else {
                            _octotelProducts.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OC'
                            });
                        }

                        _productflysmarts.push({
                            ...item,
                            is_available: isAvailable,
                            product_type_code: 'OC'
                        });
                    })
                }

                if (packages.productflyultras) {
                    packages.productflyultras.forEach(item => {
                        let isAvailable = false;

                        let existItems = octotel_services.filter(x => item.code.includes(x.productCode));
                        if (existItems && existItems.length > 0) {
                            isAvailable = true;
                            let existPackage = _octotelProducts.filter(x => item.code.includes(x.productCode));
                            if (!existPackage || (existPackage && existPackage.length == 0)) {
                                _octotelProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: true,
                                    product_type_code: 'OC'
                                });
                            } else {
                                _octotelProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: false,
                                    product_type_code: 'OC'
                                });
                            }
                        } else {
                            _octotelProducts.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OC'
                            });
                        }

                        _productflyultras.push({
                            ...item,
                            is_available: isAvailable,
                            product_type_code: 'OC'
                        });
                    })
                }

                _packages.productflylites = _productflylites;
                _packages.productflysmarts = _productflysmarts;
                _packages.productflyultras = _productflyultras;
                console.log("AAAA checkProductsOctotel new _packages:   ", _packages);

                console.log("AAAA checkProductsOctotel _octotelProducts: ", packages);
                if (_octotelProducts && _octotelProducts.length > 0) {
                    isCheck = true;
                } else {
                    isCheck = false;
                }
                setPackages(_packages);
            }
        } catch (error) {
            console.log("AAAA checkProductsOctotel error: ", error);
        }
        console.log("AAAA checkProductsOctotel isCheck: ", isCheck)
        return isCheck;
    }
    const onCheckProductsOpenserve = (openserveServices) => {
        let isCheck = false;
        try {
            let _openserveProducts = [];
            let _productflylites = [];
            let _productflysmarts = [];
            let _productflyultras = [];
            let _packages = {}

            if (openserveServices && openserveServices.length > 0 && packages) {
                if (packages.productflylites) {
                    packages.productflylites.forEach(item => {
                        let isAvailable = false;

                        let existItems = openserveServices.filter(x => item.code.includes(x.ProductCode + '-'));
                        if (existItems && existItems.length > 0) {
                            isAvailable = true;
                            let existPackage = _openserveProducts.filter(x => item.code.includes(x.ProductCode + '-'));
                            if (!existPackage || (existPackage && existPackage.length == 0)) {
                                _openserveProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: true,
                                    product_type_code: 'OS'
                                });
                            } else {
                                _openserveProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: false,
                                    product_type_code: 'OS'
                                });
                            }
                        } else {
                            _openserveProducts.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OS'
                            });
                        }

                        _productflylites.push({
                            ...item,
                            is_available: isAvailable,
                            product_type_code: 'OS'
                        });
                    })
                }

                if (packages.productflysmarts) {
                    packages.productflysmarts.forEach(item => {
                        let isAvailable = false;

                        let existItems = openserveServices.filter(x => item.code.includes(x.ProductCode + '-'));
                        if (existItems && existItems.length > 0) {
                            isAvailable = true;
                            let existPackage = _openserveProducts.filter(x => item.code.includes(x.ProductCode + '-'));
                            if (!existPackage || (existPackage && existPackage.length == 0)) {
                                _openserveProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: true,
                                    product_type_code: 'OS'
                                });
                            } else {
                                _openserveProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: false,
                                    product_type_code: 'OS'
                                });
                            }
                        } else {
                            _openserveProducts.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OS'
                            });
                        }

                        _productflysmarts.push({
                            ...item,
                            is_available: isAvailable,
                            product_type_code: 'OS'
                        });
                    })
                }

                if (packages.productflyultras) {
                    packages.productflyultras.forEach(item => {
                        let isAvailable = false;

                        let existItems = openserveServices.filter(x => item.code.includes(x.ProductCode + '-'));
                        if (existItems && existItems.length > 0) {
                            isAvailable = true;
                            let existPackage = _openserveProducts.filter(x => item.code.includes(x.ProductCode + '-'));
                            if (!existPackage || (existPackage && existPackage.length == 0)) {
                                _openserveProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: true,
                                    product_type_code: 'OS'
                                });
                            } else {
                                _openserveProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: false,
                                    product_type_code: 'OS'
                                });
                            }
                        } else {
                            _openserveProducts.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OS'
                            });
                        }

                        _productflyultras.push({
                            ...item,
                            is_available: isAvailable,
                            product_type_code: 'OS'
                        });
                    })
                }

                _packages.productflylites = _productflylites;
                _packages.productflysmarts = _productflysmarts;
                _packages.productflyultras = _productflyultras;
                console.log("AAAA onCheckProductsOpenserve new _packages:   ", _packages);

                console.log("AAAA onCheckProductsOpenserve _openserveProducts1111: ", packages);
                if (_openserveProducts && _openserveProducts.length > 0) {
                    isCheck = true;
                } else {
                    isCheck = false;
                }
                setPackages(_packages);
            }
        } catch (error) {
            console.log("AAAA onCheckProductsOpenserve error: ", error);
        }
        console.log("AAAA onCheckProductsOpenserve isCheck: ", isCheck)
        return isCheck;
    }

    const mappingProductTypeCode = (type) => {
        if (type == PRODUCT_TYPES.metrofibre) {
            return PRODUCT_TYPE_CODES.metrofibre;
        }
        if (type == PRODUCT_TYPES.octotel) {
            return PRODUCT_TYPE_CODES.octotel;
        }
        if (type == PRODUCT_TYPES.vuma_core) {
            return PRODUCT_TYPE_CODES.vuma_core;
        }
        if (type == PRODUCT_TYPES.vuma_reach) {
            return PRODUCT_TYPE_CODES.vuma_reach;
        }
        if (type == PRODUCT_TYPES.openserve) {
            return PRODUCT_TYPE_CODES.openserve;
        }
    }
    const setAvailableVumaProducts = () => {
        try {
            let _productflylites = [];
            let _productflysmarts = [];
            let _productflyultras = [];
            let _packages = {}

            if (packages) {
                if (packages.productflylites) {
                    packages.productflylites.forEach(item => {
                        if (item.product_type != 'openserve') {
                            _productflylites.push({
                                ...item,
                                is_available: true,
                                product_type_code: mappingProductTypeCode(item.product_type)
                            });
                        } else {
                            _productflylites.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OS'
                            });
                        }
                    })
                }

                if (packages.productflysmarts) {
                    packages.productflysmarts.forEach(item => {
                        if (item.product_type != 'openserve') {
                            _productflysmarts.push({
                                ...item,
                                is_available: true,
                                product_type_code: mappingProductTypeCode(item.product_type)
                            });
                        } else {
                            _productflysmarts.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OS'
                            });
                        }
                    })
                }

                if (packages.productflyultras) {
                    packages.productflyultras.forEach(item => {
                        if (item.product_type != 'openserve') {
                            _productflyultras.push({
                                ...item,
                                is_available: true,
                                product_type_code: mappingProductTypeCode(item.product_type)
                            });
                        } else {
                            _productflyultras.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OS'
                            });
                        }
                    })
                }

                _packages.productflylites = _productflylites;
                _packages.productflysmarts = _productflysmarts;
                _packages.productflyultras = _productflyultras;

                setPackages(_packages);
            }
        } catch (error) {
            console.log("setAvailableProducts error: ", error);
        }
    }

    const setAvailableMetroFibreProducts = () => {
        try {
            let _productflylites = [];
            let _productflysmarts = [];
            let _productflyultras = [];
            let _packages = {}
            console.log("AAAA packages",packages)
            if (packages) {
                if (packages.productflylites) {
                    packages.productflylites.forEach(item => {
                        if (item.product_type == 'metrofibre') {
                            _productflylites.push({
                                ...item,
                                is_available: true,
                                product_type_code: 'MF'
                            });
                        } else {
                            _productflylites.push(item)
                        }
                    })
                }

                if (packages.productflysmarts) {
                    packages.productflysmarts.forEach(item => {
                        if (item.product_type == 'metrofibre') {
                            _productflysmarts.push({
                                ...item,
                                is_available: true,
                                product_type_code: 'MF'
                            });
                        } else {
                            _productflysmarts.push(item)
                        }
                    })
                }

                if (packages.productflyultras) {
                    packages.productflyultras.forEach(item => {
                        if (item.product_type == 'metrofibre') {
                            _productflyultras.push({
                                ...item,
                                is_available: true,
                                product_type_code: 'MF'
                            });
                        } else {
                            _productflyultras.push(item);
                        }
                    })
                }

                _packages.productflylites = _productflylites;
                _packages.productflysmarts = _productflysmarts;
                _packages.productflyultras = _productflyultras;

                setPackages(_packages);
            }
        } catch (error) {
            console.log("setAvailableProducts error: ", error);
        }
    }
    const setAvailableVumaReachProducts1010 = () => {
        let _productflylites = [];
        let _productflysmarts = packages?.productflysmarts || [];
        let _productflyultras = packages?.productflyultras || [];
        let _packages = {}

        if (packages && packages.productflylites) {
            packages.productflylites.forEach(item => {
                if (item.product_type == 'vuma_reach' && item.code == configData.vumareach_10_10) {
                    _productflylites.push({
                        ...item,
                        is_available: true,
                        product_type_code: 'VR',
                    });
                } else {
                    _productflylites.push({ ...item, is_available: false })
                }
            })
        }
        _packages = {
            productflylites: _productflylites,
            productflysmarts: _productflysmarts,
            productflyultras: _productflyultras,
        }
        setPackages(_packages)
    }
    const setAvailableVumaCoreProducts3030 = () => {
        let _productflylites = packages?.productFlyLites || [];
        let _productflysmarts = [];
        let _productflyultras = packages?.productflyultras || [];
        let _packages = {}

        if (packages && packages.productflysmarts) {
            packages.productflysmarts.forEach(item => {
                if (item.product_type == 'vuma_core' && item.code == configData.vumacore_30_30) {
                    _productflysmarts.push({
                        ...item,
                        is_available: true,
                        product_type_code: 'VC',
                    });
                } else {
                    _productflysmarts.push({ ...item, is_available: false })
                }
            })
        }
        _packages = {
            productflylites: _productflylites,
            productflysmarts: _productflysmarts,
            productflyultras: _productflyultras,
        }
        setPackages(_packages)
    }

    const resetAvailableProducts = () => {
        try {
            let _productflylites = [];
            let _productflysmarts = [];
            let _productflyultras = [];
            let _packages = {}

            if (packages) {
                if (packages.productflylites) {
                    packages.productflylites.forEach(item => {
                        _productflylites.push({
                            ...item,
                            is_available: false,
                        });
                    })
                }

                if (packages.productflysmarts) {
                    packages.productflysmarts.forEach(item => {
                        _productflysmarts.push({
                            ...item,
                            is_available: false,
                        });
                    })
                }

                if (packages.productflyultras) {
                    packages.productflyultras.forEach(item => {
                        _productflyultras.push({
                            ...item,
                            is_available: false,
                        });
                    })
                }

                _packages.productflylites = _productflylites;
                _packages.productflysmarts = _productflysmarts;
                _packages.productflyultras = _productflyultras;

                setPackages(_packages);
            }
        } catch (error) {
            console.log("resetAvailableProducts error: ", error);
        }
    }

    const onSelectAddress1MapOld = async (address) => {
        console.log("AAAA onSelectAddress1Map address: ", address)
        console.log("AAAA onSelectAddress1Map packages: ", packages)
        setAddressSelected(null);
        resetAvailableProducts();
        let _addressInfo = {};
        let isContinue = false;
        if (address && address.fnoInfo && address.onemapAddresses && address.onemapAddresses[0] != null) {
            // debugger
            let addressLabel = null;
            addressLabel = `${address.onemapAddresses[0].streetNo ? address.onemapAddresses[0].streetNo : ''}`;
            addressLabel += `${address.onemapAddresses[0].streetName ? `${addressLabel.length > 0 && ''} ${address.onemapAddresses[0].streetName}` : ''}`;

            _addressInfo.address_line_1 = addressLabel;
            _addressInfo.suburb = address.onemapAddresses[0].suburb ? address.onemapAddresses[0].suburb : "";
            _addressInfo.state_province_county = address.onemapAddresses[0].provinceCode ? address.onemapAddresses[0].provinceCode : "";
            _addressInfo.town_city = address.onemapAddresses[0].city ? address.onemapAddresses[0].city : "";
            _addressInfo.postal_code = address.onemapAddresses[0].postalCode ? address.onemapAddresses[0].postalCode : "";
            // _addressInfo.country.value = address.country_code ? address.country_code : "";
            _addressInfo.latitude = address.onemapAddresses[0].latitude ? address.onemapAddresses[0].latitude : "";
            _addressInfo.longitude = address.onemapAddresses[0].longitude ? address.onemapAddresses[0].longitude : "";
            _addressInfo.premiseId = address.premise_ref_isp ? address.premiserefisp : "";
            _addressInfo.mdu_name = address.fnoInfo.mdu_nme ? address.fnoInfo.mdu_nme : "";
            _addressInfo.mdu_unitno = address.fnoInfo.unit_num ? address.fnoInfo.unit_num : "";
            _addressInfo.street_name = address.onemapAddresses[0].streetName ? address.onemapAddresses[0].streetName : "";
            _addressInfo.street_number = address.onemapAddresses[0].streetNo ? address.onemapAddresses[0].streetNo : "";
            _addressInfo.apartment_name = _addressInfo.mdu_name;
            _addressInfo.apartment_number = _addressInfo.mdu_unitno;
            console.log("AAAA _addressInfo: ", _addressInfo)
            // props.checkCoverage1Map(_addressInfo)
        }
        if (_addressInfo) {
            if (_addressInfo.address_line_1) {
                if (packages && address.source == 'VC') {
                    _addressInfo.product_types = 'VC';
                    _addressInfo.premise_ref_isp = _addressInfo.premiseId;
                    setAddressSelected(_addressInfo);
                    isContinue = true;
                } else if (packages && address.source == 'Openserve') {
                    if (address.coverage && address.coverage.products && address.coverage.products.length > 0) {
                        _addressInfo.product_types = 'OS';
                        _addressInfo.openserve_ref_isp = _addressInfo.premiseId;
                        isContinue = true;
                    }
                } else if (packages && address.coverage && address.coverage.available) {
                    _addressInfo.product_types = 'VR';
                    _addressInfo.premise_ref_isp = _addressInfo.premiseId;
                    setAddressSelected(_addressInfo);
                    isContinue = true;
                }
            }
        }
        if (isContinue) {
            setAddressHome(_addressInfo)
            setAddressSelected(_addressInfo)
            let locationAvaible = await checkLocationAvaibleOrder();
            if (locationAvaible.isCheck) {
                if (locationAvaible.building && locationAvaible.building.length > 0) {
                    setBuilding(locationAvaible.building)
                    setOpenModalBuilding(true);
                    setChoosePackage(true)
                } else setShowModal(true)
            }
        }
    }

    function buildAddress(address) {
        if (!address) return {};
  
        if (address.openserve?.AddressInfo) {
           address.source = "Openserve";
           return parseOpenserve(address);
        }
  
        if (address.vuma) {
           address.source = address.vuma.product_types;
           return parseVuma(address);
        }
  
        if (address.octotel) {
           address.source = "Octotel";
           return parseOctotel(address);
        }
  
        if (address.vumaTactical) {
        //    address.source = "VR";
           return parseVumaTactical(address);
        }
  
        if (address.metrofibre) {
           address.source = "metrofibre";
           return parseMetrofibre(address);
        }
  
        return {};
     }
     function parseOpenserve(address) {
        const info = address.openserve.AddressInfo;
        const result = {
           address_line_1: `${info.LR_STREET_NO || ""} ${info.LR_STREET || ""}`.trim(),
           suburb: info.LR_SUBURB || "",
           state_province_county: info.LR_PROVINCE || "",
           town_city: info.LR_TOWN || "",
           latitude: info.LR_LAT || "",
           longitude: info.LR_LON || "",
           premisesid: info.AMID || "",
           street_name: info.LR_STREET || "",
           street_number: info.LR_STREET_NO || ""
        };
  
        // building info
        const buildingInfo =
           info.buildingNumberInfo?.buildingInfo?.[0] || null;
  
        if (buildingInfo) {
           result.apartment_name = buildingInfo.BUILDING_NAME || "";
           result.apartment_number = buildingInfo.NUM || "";
        }
  
        return result;
     }
  
     function parseVuma(address) {
        const v = address.vuma;
        return {
           address_line_1: `${v.street_number || ""} ${v.street_name || ""}`.trim(),
           suburb: v.suburb || "",
           state_province_county: v.province || "",
           town_city: v.city || "",
           postal_code: v.postal_code || "",
           latitude: v.latitude || "",
           longitude: v.longitude || "",
           premisesid: v.premise_ref_isp || v.location_reference || "",
           mdu_name: v.mdu_name || "",
           mdu_unitno: v.mdu_unitno || "",
           street_name: v.street_name || "",
           street_number: v.street_number || "",
           network_type: v.networktype || "",
           network_readiness_status: v.network_readiness_status || "",
           pre_order: v.pre_order
        };
     }
     function parseOctotel(address) {
        const o = address.octotel;
        const map = o.onemapAddress || {};
  
        const ont = o.lines
           ?.filter((item) => item.available_action === "RECONNECT" && !item.active_service)
           ?.map((item) => item.ont_serial) || [];
  
        return {
           address_line_1: `${o.street_number || ""} ${o.street_name || ""}`.trim(),
           latitude: map.centLatitude || "",
           longitude: map.centLongitude || "",
           street_name: o.street_name || "",
           street_number: o.street_number || "",
           state_province_county: map.provinceCode || "",
           town_city: map.city || "",
           postal_code: map.postalCode || "",
           ont_serial: ont,
           uuid: o.uuid || "",
           premisesid: o.uuid || ""
        };
     }
     function parseVumaTactical(address) {
        const v = address.vumaTactical;
        return {
           address_line_1: `${v.street_number || ""} ${v.street_name || ""}`.trim(),
           suburb: v.suburb || "",
           state_province_county: v.province || "",
           town_city: v.city || "",
           postal_code: v.postal_code || "",
           latitude: v.latitude || "",
           longitude: v.longitude || "",
           premisesid: v.premise_ref_isp || v.premisesid || "",
           mdu_name: v.mdu_name || "",
           mdu_unitno: v.mdu_unitno || "",
           street_name: v.street_name || "",
           street_number: v.street_number || "",
           network_readiness_status: v.network_readiness_status || "",
           tactical: true,
           pre_order:v.pre_order
        };
     }
     function parseMetrofibre(address) {
        const m = address.metrofibre;
        const map = m.onemapAddress || {};
        return {
           address_line_1: m.address || "",
           town_city: map.city || "",
           postal_code: map.postalCode || "",
           latitude: m.coordinates?.lat || "",
           longitude: m.coordinates?.lon || "",
           premisesid: `${m.coverage?.PolygonId};${m.addressId}`,
           metrofibre_ref_isp: `${m.coverage?.PolygonId};${m.addressId}`,
           street_name: map.streetName || "",
           street_number: map.streetNo || "",
           state_province_county: map.provinceCode || ""
        };
     }
  
     const onSelectAddress1Map = async (address) => {
        console.log("AAAA onSelectAddress1Map address: ", address)
        setAddressSelected(null);
        resetAvailableProducts();
  
        let isContinue = false; //FAKE
        if (address && address['vuma tactical']) {
           address.vumaTactical = address['vuma tactical'];
           if (address.vumaTactical?.filename == 'Reach Tactical') {
            address.source = 'VR';
           } else if (address.vumaTactical?.filename == 'Core Tactical') {
            address.source = 'VC';
           }
        }
        let _addressInfo = buildAddress(address);
        console.log("AAAA _addressInfo: ", _addressInfo)
        if (_addressInfo) {
           if (_addressInfo.address_line_1) {
              if (packages && address.source == 'VC') {
                 _addressInfo.product_types = 'VC';
                 _addressInfo.premise_ref_isp = _addressInfo.premisesid;
                 setAddressSelected(_addressInfo);
                 isContinue = true;
              } else if (packages && address.source == 'Openserve') {
                 if (address.openserve.ftthInfrastructure && address.openserve.ftthInfrastructure.ftthInfo && address.openserve.ftthInfrastructure.ftthInfo[0] && address.openserve.ftthInfrastructure.ftthInfo[0].ftthProductInfo.length > 0) {
                    _addressInfo.product_types = 'OS';
                    _addressInfo.openserve_ref_isp = _addressInfo.premisesid;
                    isContinue = true;
                 }
              } else if (packages && address.source == 'VR') {
                 _addressInfo.product_types = 'VR';
                 _addressInfo.premise_ref_isp = _addressInfo.premisesid;
                 setAddressSelected(_addressInfo);
                 isContinue = true;
              } else if (packages && address.source == 'Octotel') {
                 _addressInfo.product_types = 'OC';
                 setAddressSelected(_addressInfo);
                 isContinue = true;
              } else if (packages && address.source == 'metrofibre') {
                 _addressInfo.product_types = 'MF';
                 setAddressSelected(_addressInfo);
                 isContinue = true;
              }
           }
        }
        if (isContinue) {
           _addressInfo.uuid = address.octotel && address.octotel.uuid ? address.octotel.uuid : ""
           // if (_addressInfo && _addressInfo.network_readiness_status && checkAddressPreorder(_addressInfo.network_readiness_status)) {
           //     _addressInfo.pre_order_allowed = true;
           // }
           _addressInfo.pre_order_allowed = _addressInfo.pre_order;
           setAddressHome(_addressInfo)
           setAddressSelected(_addressInfo)
           if (_addressInfo && _addressInfo.tactical) {
              if (_addressInfo.product_types == 'VR') setAvailableVumaReachProducts1010();
              else if (_addressInfo.product_types == 'VC') setAvailableVumaCoreProducts3030();
              setChoosePackage(true)
           } else if (_addressInfo.pre_order) {
              setAvailableVumaProducts();
              setShowModal(true)
           }
           else {
              let locationAvaible = await checkLocationAvaibleOrder();
              // locationAvaible.isCheck = true;//FAKE
              if (locationAvaible.isCheck) {
                 if (locationAvaible.building && locationAvaible.building.length > 0) {
                    setBuilding(locationAvaible.building)
                    setOpenModalBuilding(true);
                    setChoosePackage(true)
                 } else setShowModal(true)
              }
           }
        }
     }
  

    const setAvailableVumaReachProducts = async () => {
        try {
            let _productflylites = [];
            let _productflysmarts = [];
            let _productflyultras = [];
            let _packages = {}

            if (packages) {
                if (packages.productflylites) {
                    packages.productflylites.forEach(item => {
                        if (item.product_type == 'vuma_reach') {
                            _productflylites.push({
                                ...item,
                                is_available: true,
                                product_type_code: 'VR'
                            });
                        } else _productflylites.push(item)
                    })
                }

                if (packages.productflysmarts) {
                    packages.productflysmarts.forEach(item => {
                        if (item.product_type == 'vuma_reach') {
                            _productflysmarts.push({
                                ...item,
                                is_available: true,
                                product_type_code: 'VR'
                            });
                        } else {
                            _productflysmarts.push(item);
                        }
                    })
                }

                if (packages.productflyultras) {
                    packages.productflyultras.forEach(item => {
                        if (item.product_type != 'vuma_reach') {
                            _productflyultras.push({
                                ...item,
                                is_available: true,
                                product_type_code: 'VR'
                            });
                        } else {
                            _productflyultras.push(item);
                        }
                    })
                }

                _packages.productflylites = _productflylites;
                _packages.productflysmarts = _productflysmarts;
                _packages.productflyultras = _productflyultras;
                console.log("AAAA setAvailableVumaReachProducts _packages: ", _packages)

                setPackages(_packages);
            }
        } catch (error) {
            console.log("setAvailableProducts error: ", error);
        }
    }

    const { classes, language } = props;

    return (
        <>
            <LandingPageV2View
                language={language}
                classes={classes}
                packages={packages}
                address={address}
                choosePackage={choosePackage}
                showModal={showModal}
                showTerm={showTerm}
                showListAddresses={showListAddresses}
                addresses={addresses}
                addressSelected={addressSelected}
                searchType={searchType}
                ispLocation={ispLocation}
                openserveServices={openserveServices}
                addressInfor={addressInfor}
                openModalBuilding={openModalBuilding}
                building={building}
                packageConfirmation={packageConfirmation}
                onSelectPackage={onSelectPackage}
                setAddress={setAddress}
                setChoosePackage={setChoosePackage}
                setShowModal={setShowModal}
                onShowTerm={onShowTerm}
                setAddressSelected={onSetAddressSelected}
                setShowListAddresses={setShowListAddresses}
                setSearchType={setSearchType}
                setISPLocation={setISPLocation}
                setAddressInfor={setAddressInfor}
                onCloseModalBuilding={() => setOpenModalBuilding(false)}
                onSetBuildingSelected={onSetBuildingSelected}
                setAddress1Map={setAddress1Map}
                onSelectAddress1Map={onSelectAddress1Map}
            />
            {showLoading && <CustomLoading
                open={showLoading}
                handleClose={() => setShowLoading(false)}
            />}
            {message && message.show && <CustomAlert
                open={message.show}
                title={message.title ? message.title : null}
                message={message.content ? message.content : null}
                isConfirm={message.isConfirm ? message.isConfirm : false}
                customMessage={message.customMessage ? message.customMessage : null}
                showButtonClose={true}
                onClose={() => setMessage({})}
                confirmAction={message.confirmAction ? message.confirmAction : null}
            />}
        </>
    )
}
